import React from 'react'
import { Done } from '@mui/icons-material'
import { Modal } from 'antd'
import CustomInput from '../../../Primitives/input'
import { useAuth0 } from '@auth0/auth0-react'
import userClient from '../../../Api/Lirari/Clients/userClient'
import { useAtom } from 'jotai'
import { myUserAtom } from '../../../State/Musician/myUserAtom'
import { Skill } from '../../../Api/Lirari/Types/skill'
import { unauthenticatedUserAtom } from '../../../State/Musician/unauthenticatedUserAtom'
import { useParams } from 'react-router-dom'

const MusicianSkills = ({ editMode }: { editMode: boolean }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [unauthenticatedUser] = useAtom(unauthenticatedUserAtom)
  const [skills, setSkills] = React.useState<string[]>([])
  const [skill1, setSkill1] = React.useState('')
  const [skill2, setSkill2] = React.useState('')
  const [skill3, setSkill3] = React.useState('')
  const { uid: userId } = useParams()

  const [myUser, setMyUser] = useAtom(myUserAtom)
  const { isAuthenticated, getAccessTokenSilently } = useAuth0()

  React.useEffect(() => {
    const skillSet =
      userId == myUser.id
        ? myUser.userSkills.sort((a, b) => (a.index < b.index ? -1 : 1)).map((us) => us.name)
        : userId == unauthenticatedUser.id
          ? unauthenticatedUser.userSkills.sort((a, b) => (a.index < b.index ? -1 : 1)).map((us) => us.name)
          : ['Pianist', 'Buzuqist', 'Singer']

    setSkills(skillSet)
    setSkill1(skillSet[0] || '')
    setSkill2(skillSet[1] || '')
    setSkill3(skillSet[2] || '')
  }, [myUser.id, myUser.userSkills, unauthenticatedUser.id, unauthenticatedUser.userSkills, userId])

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleOk = async () => {
    const newSkills = []
    if (skill1.trim().length > 0) {
      newSkills.push(skill1)
    }
    if (skill2.trim().length > 0) {
      newSkills.push(skill2)
    }
    if (skill3.trim().length > 0) {
      newSkills.push(skill3)
    }
    if (isAuthenticated) {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          scope: 'user:all',
        },
      })
      await userClient.updateUser(
        myUser.id,
        {
          youTubeUrl: myUser.socialLinks.youtube,
          soundCloudUrl: myUser.socialLinks.soundCloud,
          spotifyUrl: myUser.socialLinks.spotify,
        },
        token,
      )
      await userClient.overwriteUserSkills(myUser.id, newSkills, token)
      setSkills(newSkills)
      setMyUser({
        ...myUser,
        userSkills: newSkills.map(
          (skill) =>
            ({
              id: '',
              name: skill,
            }) as Skill,
        ),
      })
    }
    setIsModalOpen(false)
  }

  const skillsModal = (
    <Modal centered open={isModalOpen} closable={false} footer={[]}>
      <div className="flex flex-col items-center">
        <CustomInput value={skill1} placeholder="Skill 1" onChange={(e) => setSkill1(e.target.value)} />
        <CustomInput value={skill2} placeholder="Skill 2" onChange={(e) => setSkill2(e.target.value)} />
        <CustomInput value={skill3} placeholder="Skill 3" onChange={(e) => setSkill3(e.target.value)} />
        <button
          className="flex p-0 mt-2.5 justify-center items-center size-12 rounded-full bg-white hover:bg-[#cdcdcd]/90 [&>svg]:text-black"
          onClick={handleOk}
        >
          <Done />
        </button>
      </div>
    </Modal>
  )

  switch (skills.length) {
    case 0:
      return (
        <div
          className={`flex justify-center items-center max-w-[250px] m-auto min-h-12 text-white [&:nth-child(1)]:text-center text-lg lg:text-[22px] ${editMode ? 'cursor-pointer' : ''}`}
          onClick={() => (editMode && !isModalOpen ? showModal() : null)}
        >
          <div className="w-[12vw] max-w-[300px] lg:w-[20vw]">
            {userId == unauthenticatedUser.id ? '' : userId == myUser.id ? 'Enter Skills Here' : ''}
          </div>
          {skillsModal}
        </div>
      )
    case 1:
      return (
        <div
          className={`flex justify-center items-center max-w-[250px] m-auto min-h-12 text-white [&:nth-child(1)]:text-center text-lg lg:text-[22px] ${editMode ? 'cursor-pointer' : ''}`}
          onClick={() => (editMode && !isModalOpen ? showModal() : null)}
        >
          <div className="w-[12vw] max-w-[200px] lg:w-[20vw]">{skills[0]}</div>
          {skillsModal}
        </div>
      )
    case 2:
      return (
        <div
          className={`flex justify-center items-center max-w-[500px] m-auto min-h-12 text-white text-lg lg:text-[22px] ${editMode ? 'cursor-pointer' : ''}`}
          onClick={() => (editMode && !isModalOpen ? showModal() : null)}
        >
          <div className="w-[12vw] max-w-[200px] lg:w-[20vw] text-end w-1/2">{skills[0]}</div>
          <div className="size-4 my-0 mx-[1vw] bg-white rounded-full inline-block"></div>
          <div className="w-[12vw] max-w-[200px] lg:w-[20vw] text-start w-1/2">{skills[1]}</div>
          {skillsModal}
        </div>
      )
    case 3:
      return (
        <div
          className={`flex justify-center items-center text-white max-w-[800px] m-auto min-h-[50px] text-lg lg:text-[22px] ${editMode ? 'cursor-pointer' : ''}`}
          onClick={() => (editMode && !isModalOpen ? showModal() : null)}
        >
          <div className="text-end w-1/3">{skills[0]}</div>
          <div className="size-4 my-0 mx-[1vw] bg-white rounded-full inline-block"></div>
          <div className="text-center">{skills[1]}</div>
          <div className="size-4 my-0 mx-[1vw] bg-white rounded-full inline-block"></div>
          <div className="text-start w-1/3">{skills[2]}</div>
          {skillsModal}
        </div>
      )
  }
}

export default MusicianSkills
